<template>
    <div class="r-auth-register-company container">
        <h2>Create account</h2>
        <div class="row justify-content-center">
            <form
                class="col-lg-12"
                @submit.prevent="handleSubmit"
            >
                <h4 class="mt-4 mb-4">Register campanies.</h4>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState({
                authData: state => state.auth ? state.auth.data : {},
            }),
        },

        methods: {
            async handleSubmit() {
                const { role, name, email, password } = this.authData;

                const credentials = {
                    role_id: role.value,
                    name,
                    email,
                    password,
                };
                console.log(credentials);
                // const isRegistered = await this.$store.dispatch('auth/register', credentials);
                // if (isRegistered) {
                //     this.$router.push({ name: 'auth-login'});
                // }
            },
        },


        components: {}
    };
</script>
